/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);


/* global debounce */
if (!customElements.get('cart-attributes')) {
  class CartAttributes extends HTMLElement {
    constructor() {
      super();

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }
    init() {
      this.debouncedUpdate = debounce(this.handleChange.bind(this), 300);

      this.addEventListener('change', (evt) => {
        if (evt.target.matches('input[type="checkbox"][name^="attributes["]')) {
          this.debouncedUpdate(evt);
        }
      });

      this.syncInitialState();
    }

    handleChange(evt) {
      const input = evt.target;
      const match = input.name.match(/^attributes\[(.+)\]$/);
      if (!match) return;

      const key = match[1];

      this.fetchRequestOpts.body = JSON.stringify({
        attributes: {
          [key]: input.checked ? input.value || 'Yes' : ''
        }
      });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }

    syncInitialState() {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          this.querySelectorAll('input[name^="attributes["]').forEach((input) => {
            const match = input.name.match(/^attributes\[(.+)\]$/);
            if (!match) return;

            const key = match[1];
            input.checked = cart.attributes?.[key] === (input.value || 'Yes');
          });
        });
    }
  }

  customElements.define('cart-attributes', CartAttributes);
}